import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            {contactData.tag}
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-3">
            {contactData.title}
          </h2>
          <p className="text-foreground-500 text-sm leading-relaxed max-w-2xl mx-auto mb-8">
            {contactData.desc}
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {contactData.tips.map((tip, idx) => (
              <div
                key={idx}
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-200/70 border border-background-300/50 text-sm text-foreground-400"
              >
                <i className="ri-check-line text-accent-400 text-sm"></i>
                {tip}
              </div>
            ))}
          </div>

          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-lg bg-primary-500/10 border border-primary-500/30">
            <i className="ri-mail-line text-primary-400 text-lg"></i>
            <span className="text-primary-400 font-medium text-base">{contactData.email}</span>
            <button className="ml-2 px-4 py-1.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
              复制邮箱
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}